import React, { useCallback, useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { MdArrowForward, MdPlayArrow } from "react-icons/md";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import ContainedButton from "components/layout/form/containedButton";
import Loading from "components/layout/loading";
import Stepper from "components/layout/Stepper";
import api from "services/api";
import {
  Body,
  ButtonContainer,
  Container,
  Content,
  HeaderContainer,
  Section,
  SideBanner,
  SuccessContainer
} from "./styles";

const VerificarEmail = () => {
  const [emailLoading] = useState({
    title: "Validação de E-mail",
    subTitle: "",
    text: "Carregando..."
  });

  const [emailSuccess] = useState({
    title: "E-mail validado!",
    subTitle:
      "Agora você pode acessar seu portal e visualizar todas suas unidades em um único login.",
    text: "Seu e-mail foi validado com sucesso!"
  });

  const [emailExpiration] = useState({
    title: "E-mail expirado!",
    subTitle:
      "O seu e-mail de ativação expirou, para validar novamente basta você reenvia-lo novamente para ativar",
    text:
      "Não foi possível concluir seu cadastro, seu e-mail de ativação foi expirado, favor tente novamente"
  });

  const [loading, setLoading] = useState(false);

  const [emailState, setEmailState] = useState(emailLoading);

  const [errorState, setErrorState] = useState(null);

  const [steppers, setSteppers] = useState(["Validação E-mail"]);

  const requestValidationEmail = useCallback(
    async (token, userId) => {
      setLoading(true);
      const body = {
        token
      };

      try {
        await api.post(
          `/industrial/customer/v1/users/${userId}/validations`,
          body
        );
        setEmailState(emailSuccess);
        setSteppers(["E-mail Validado"]);
      } catch (error) {
        setEmailState(emailExpiration);
        setErrorState(1);
        setSteppers(["Token Expirado"]);
      }
      setLoading(false);
    },
    [setLoading, api, setEmailState, setErrorState]
  );

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get("token");
    const userId = params.get("user-id");
    requestValidationEmail(token, userId);
  }, []);

  return (
    <Container>
      <SideBanner>
        <Link to="/">
          <img src="/static/ultragaz-logo-blue.svg" alt="Logo da Ultragaz" />
        </Link>
        <Stepper
          activated={2}
          errorState={errorState}
          steppers={steppers}
          scrollToEnd={false}
        />
      </SideBanner>
      <Content>
        <Body>
          <Section>
            <HeaderContainer>
              <span>
                <MdPlayArrow />
                &nbsp;&nbsp;Validação de E-mail
              </span>
              <h1>{emailState.title}</h1>
              <h2>{emailState.subTitle}</h2>
            </HeaderContainer>

            <SuccessContainer errorState={errorState}>
              {!loading &&
                (!errorState ? (
                  <RiCheckboxCircleLine size={60} />
                ) : (
                  <IoMdCloseCircle size={60} />
                ))}
              <p>{emailState.text}</p>
            </SuccessContainer>

            <ButtonContainer>
              <Link to="/">
                <ContainedButton
                  color="#4EC937"
                  TrailingIcon={() => <MdArrowForward size={20} />}
                >
                  Acesse o portal
                </ContainedButton>
              </Link>
            </ButtonContainer>
          </Section>
        </Body>
      </Content>
      {loading && <Loading />}
    </Container>
  );
};

export default VerificarEmail;
